import type { ResolvedQuizSponsorsStylePresetConfiguration } from '@/lib/domain/sponsorsStylePreset';
import type { BrandThemeRecipeV2 } from '@/lib/embed/brandTheme';
import type { StyleOverrideFontFace } from '@/lib/embed/styleOverrides';
import { getPublicStorageUrl } from '@/lib/services/storage';

export interface SponsorsStylePresetWebRuntime {
  appearance: ResolvedQuizSponsorsStylePresetConfiguration['web']['themeMode'];
  theme: BrandThemeRecipeV2 | null;
  fontFaces: StyleOverrideFontFace[];
}

export function buildSponsorsStylePresetWebRuntime(
  configuration: ResolvedQuizSponsorsStylePresetConfiguration
): SponsorsStylePresetWebRuntime {
  if (!configuration.web.customStyleEnabled) {
    return {
      appearance: 'light',
      theme: null,
      fontFaces: [],
    };
  }

  const theme = configuration.web.themeRecipe;
  const referencedFamilies = new Set(
    [theme.titleFontFamily, theme.bodyFontFamily]
      .filter((family): family is string => Boolean(family?.trim()))
      .map((family) => family.trim().toLowerCase())
  );
  const fontFaces: StyleOverrideFontFace[] = configuration.fontAssets
    .filter((asset) => referencedFamilies.has(asset.family.trim().toLowerCase()))
    .map((asset) => ({
      family: asset.family,
      format: asset.format,
      src: getPublicStorageUrl(asset.storageBucket, asset.storagePath),
    }));

  return {
    appearance: configuration.web.themeMode,
    theme,
    fontFaces,
  };
}
